import { UserFormPermissions, UserGeneralPermissions, UserPermissions, UserRoles } from "./user";
export const getAllGeneralPermissions = () => Object.values(UserGeneralPermissions);
export const mapNewPermissionsToOldPermissions = (params) => {
    const generalPermissions = params.generalPermissions ?? [];
    const formPermissions = params.formPermissions ?? [];
    const result = [];
    if (generalPermissions.includes(UserGeneralPermissions.Contacts)) {
        result.push(UserPermissions.Contacts);
    }
    if (generalPermissions.includes(UserGeneralPermissions.Bank)) {
        result.push(UserPermissions.Bank);
    }
    if (formPermissions.includes(UserFormPermissions.TapToPayPayments)) {
        result.push(UserPermissions.TapToPay);
    }
    if (generalPermissions.includes(UserGeneralPermissions.UserManagement)) {
        result.push(UserPermissions.UserManagement);
    }
    if (formPermissions.includes(UserFormPermissions.EditForm)) {
        result.push(UserPermissions.Donation);
        result.push(UserPermissions.Ticketing);
    }
    if (formPermissions.includes(UserFormPermissions.Receipt)) {
        result.push(UserPermissions.Receipt);
    }
    return result;
};
export const hasPermissionOnAtLeastOneForm = (newFormPermissions) => {
    return Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.EditForm));
};
export const hasPermissionOnAtLeastOneFormPayment = (newFormPermissions) => {
    return Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.ManagePayments));
};
export const hasPermissionOnAtLeastOneFormReceipt = (newFormPermissions) => {
    return Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.Receipt));
};
export const hasPermissionOnAllEditForms = (newFormPermissions) => {
    return (Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.EditForm)) &&
        !newFormPermissions?.permissionFormIds.length);
};
export const hasPermissionOnAllPayments = (newFormPermissions) => {
    return (Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.ManagePayments)) &&
        !newFormPermissions?.permissionFormIds.length);
};
export const hasPermissionOnAllReceipts = (newFormPermissions) => {
    return (Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.Receipt)) &&
        !newFormPermissions?.permissionFormIds.length);
};
export const hasPermissionOnUserManagement = (newFormPermissions) => {
    return Boolean(newFormPermissions?.generalPermissions.includes(UserGeneralPermissions.UserManagement));
};
export const hasPermissionOnContacts = (newFormPermissions) => {
    return Boolean(newFormPermissions?.generalPermissions.includes(UserGeneralPermissions.Contacts));
};
export const hasPermissionOnBank = (newFormPermissions) => {
    return Boolean(newFormPermissions?.generalPermissions.includes(UserGeneralPermissions.Bank));
};
export const hasPermissionOnTapToPay = (newFormPermissions) => {
    return Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.TapToPayPayments));
};
export const canReceiveVisitorReport = ({ role, formPermissions, permissionFormIds, }) => {
    if (role === UserRoles.Owner) {
        return true;
    }
    return Boolean(formPermissions?.includes(UserFormPermissions.ManagePayments)) && !permissionFormIds?.length;
};
export const hasPermissionOnFormPayment = ({ newFormPermissions, formId, }) => {
    return (Boolean(newFormPermissions?.formPermissions.includes(UserFormPermissions.ManagePayments)) &&
        (!newFormPermissions?.permissionFormIds.length || newFormPermissions?.permissionFormIds.includes(formId)));
};
